import React, { useEffect, useState } from "react";
import MainLayout1 from "Components/UI/Layout/MainLayout1";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { Tab, Tabs } from "@mui/material";
import Stack from "@mui/material/Stack";

import { useNavigate, useLoaderData } from "react-router-dom";
import { createClientAccount as CreateClientAccountReq } from "API/swesum";
import usePost from "Hooks/usePost";
import { getAllClientArticles } from "API/swesum";
import dayjs from "dayjs";
import ClientAccountFormGeneral from "Components/Account/ClientAccountFormGeneral";
import ClientAccountFormSystem from "Components/Account/ClientAccountFormSystem";
import { useClients } from "Context/Clients";
import { useInvoices } from "Context/Invoices";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

const initialState = {
  Amount: 0,
  ClientArticleId: "",
  InvoiceId: "",
  ParseMessage: "",
  ParseStatus: "",
  SystemStatus: 1,
  Createtime: dayjs(),
  PayedId: "",
  Id: "",
  ClientId: "",
  BookRefId: "",
};

export default function CreateClientAccount() {
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const [clientArticles, setClientArticles] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const { openError } = usePopupNotificationContext();

  useEffect(() => {
    const asyncFetchData = async () => {
      const tmpClientArticles = await getAllClientArticles();
      setClientArticles(tmpClientArticles);
    };
    asyncFetchData();
    if (!hasFetchedAll) {
      fetchClients();
    }
  }, []);

  const createAccReq = usePost({
    mtnFunc: (body) => CreateClientAccountReq(body),
    onError: () => {
      openError("Ett fel uppstod när Kontot skapades.");
    },
    onSuccess: (data) => {
      navigate(`/clientsaccounts/${data.Id}`);
    },
  });

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };
  const [tabIndex, setTabindex] = useState(0);

  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, pt: 8, pb: 3, pl: 3, pr: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Skapa klientkonto
                </Typography>
                <Tabs
                  value={tabIndex}
                  onChange={handleTabSwitch}
                  sx={{ marginBottom: "2rem" }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab label="Allmänt" />
                  <Tab label="System" />
                </Tabs>
                <TabPanel value={tabIndex} index={0}>
                  <ClientAccountFormGeneral
                    formData={formData}
                    clients={clients}
                    clientArticles={clientArticles}
                    handleInputChange={handleInputChange}
                  />
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                  <ClientAccountFormSystem
                    formData={formData}
                    clients={clients}
                    clientArticles={clientArticles}
                    handleInputChange={handleInputChange}
                  />
                </TabPanel>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 4,
                  }}
                >
                  <Stack direction="row" spacing={3}>
                    <Button onClick={() => navigate(-1)}>Stäng</Button>
                    <Button
                      onClick={() => createAccReq.post(formData)}
                      variant="contained"
                    >
                      Spara
                    </Button>
                  </Stack>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
